/** @jsxImportSource @emotion/react */
import React, { useState } from 'react'
import styled from '@emotion/styled'
import DefaultImage from '../../../../assets/ktp/default-image.png'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1rem;
`

const ImagePreview = styled.label`
  width: 100%;
  max-width: 10rem;
  aspect-ratio: 1 / 1;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  background: #f5f5f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  &:hover {
    transform: ${props => (props.disabled ? 'none' : 'scale(1.015)')};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover .overlay {
    opacity: ${props => (props.disabled ? 0 : 1)};
  }
`

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: bold;
  opacity: 0;
  transition: 0.25s ease;
  pointer-events: none;
`

const UploadButton = styled.label`
  padding: 0.65rem 1.3rem;
  border-radius: 10px;
  background: #1976d2;
  color: white;
  cursor: pointer;
  width: 100%;
  max-width: 10rem;
  text-align: center;
  font-size: 0.9rem;
  transition: 0.3s ease;
  font-weight: 500;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  &:hover {
    background: #1157a3;
  }

  &:active {
    transform: scale(0.97);
  }
`

const FileInfo = styled.div`
  font-size: 0.8rem;
  color: #666;
  text-align: center;
  max-width: 20rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`

const PhotoUploader = ({
  id = 'photo-uploader',
  preview = '',
  onChange,
  onlyPreview = false,
  disabled = false,
}) => {
  const [fileName, setFileName] = useState(preview || 'Belum ada foto')

  const handleChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      setFileName(e.target.files[0].name)
    }
    onChange(e)
  }

  const previewSrc = preview || DefaultImage

  return (
    <Wrapper>
      <ImagePreview htmlFor={onlyPreview ? undefined : id} disabled={disabled}>
        <img src={previewSrc} alt='Preview' />
        {!onlyPreview && !disabled && (
          <Overlay className='overlay'>Ganti Foto</Overlay>
        )}
      </ImagePreview>

      {/* Upload button */}
      {!onlyPreview && (
        <UploadButton htmlFor={id} disabled={disabled}>
          Pilih
        </UploadButton>
      )}

      {/* File info */}
      {!onlyPreview && (
        <>
          <FileInfo>{fileName}</FileInfo>
          <FileInfo>
            <span style={{ opacity: 0.8 }}>Format: JPG/PNG — Max 5MB</span>
          </FileInfo>
        </>
      )}

      {/* Hidden file input */}
      {!onlyPreview && (
        <input
          id={id}
          type='file'
          accept='image/*'
          onChange={handleChange}
          hidden
          disabled={disabled}
        />
      )}
    </Wrapper>
  )
}

export default PhotoUploader
